import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons'

// Sets up Vue for the vue-awesome library.
export default function (Vue) {
  Vue.component('icon', Icon)
}



// WEBPACK FOOTER //
// ./src/core/setup-icons.js